import React from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const ErrorTypography: React.FC<{ errorCode: string }> = (props) => {
    const { t } = useTranslation('errors', {
        keyPrefix: 'ERROR',
    });

    return (
        <Typography sx={{ color: 'red' }}>{t(props.errorCode)}</Typography>
    );
};
